import { PipeTransform, Pipe } from '@angular/core';
import ProductHelper from '../helpers/product-helper';

@Pipe({
  name: 'abbreviatedProductType'
})
export class AbbreviatedProductTypePipe implements PipeTransform {
  transform(type: string, otherProductName: string) {
    return ProductHelper.getAbbreviatedType(type, otherProductName);
  }
}
